/**
 * Boarding visibility rules (shared by BookForm and BookGuestSelector):
 * 1. Only boardings with board_id codes in range [1..6] and 255 are selectable.
 * 2. Boarding codes in range [4..6] ("treatment" packages) are visible only
 *    if the guest age is greater or equals the resort `treatment_from` value.
 *
 * @param boardings array: [{board_id, name, description, ...}, ...]
 * @param age number guest age
 * @param treatmentFrom number|null resort `treatment_from` property
 * @returns array filtered boardings visible for this guest
 */
export function filterBoardingsForGuest(boardings, age, treatmentFrom) {
  if (!Array.isArray(boardings)) return [];
  const from = treatmentFrom === null || treatmentFrom === undefined ? null : Number(treatmentFrom);
  return boardings.filter((b) => {
    const id = parseInt(b.board_id, 10);
    // Rule 1: allow only codes [1..6] and 255
    if (!((id >= 1 && id <= 6) || id === 255)) return false;
    // Rule 2: codes [4..6] require age >= treatment_from
    if (id >= 4 && id <= 6) {
      return from === null || Number.isNaN(from) ? true : age >= from;
    }
    return true;
  });
}
